export const mimeTypeToIconMapping = {
	'image/jpeg': {
		icon: 'ri-image',
		color: '#FFC107',
	},
	'image/png': {
		icon: 'ri-image-2',
		color: '#4CAF50',
	},
	'application/pdf': {
		icon: 'ri-file-pdf',
		color: '#F44336',
	},
	'application/msword': {
		icon: 'ri-file-word',
		color: '#2196F3',
	},
	'application/vnd.ms-excel': {
		icon: 'ri-file-excel',
		color: '#4CAF50',
	},
	'application/vnd.ms-powerpoint': {
		icon: 'ri-file-ppt',
		color: '#FF5722',
	},
	'text/plain': {
		icon: 'ri-file-text',
		color: '#607D8B',
	},
	'application/zip': {
		icon: 'ri-file-zip',
		color: '#9C27B0',
	},
	'audio/mpeg': {
		icon: 'ri-music',
		color: '#FF9800',
	},
	'audio/x-wav': {
		icon: 'ri-music-2',
		color: '#FFC107',
	},
	'video/mp4': {
		icon: 'ri-video',
		color: '#E91E63',
	},
	'video/quicktime': {
		icon: 'ri-movie',
		color: '#FF5722',
	},
	'video/x-msvideo': {
		icon: 'ri-film',
		color: '#2196F3',
	},
	'text/html': {
		icon: 'ri-file-code',
		color: '#795548',
	},
	'application/json': {
		icon: 'ri-file-code',
		color: '#607D8B',
	},
	'application/javascript': {
		icon: 'ri-file-code',
		color: '#FF9800',
	},
	'application/xml': {
		icon: 'ri-file-code',
		color: '#9C27B0',
	},
	'application/octet-stream': {
		icon: 'ri-file',
		color: '#607D8B',
	},
	'application/vnd.android.package-archive': {
		icon: 'ri-file',
		color: '#9E9E9E',
	},
	'application/x-tar': {
		icon: 'ri-file',
		color: '#795548',
	},
	'application/x-bzip': {
		icon: 'ri-file',
		color: '#FF5722',
	},
	'application/x-rar-compressed': {
		icon: 'ri-file',
		color: '#FFC107',
	},
	'application/x-7z-compressed': {
		icon: 'ri-file',
		color: '#4CAF50',
	},
	'application/x-gzip': {
		icon: 'ri-file',
		color: '#F44336',
	},
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
		icon: 'ri-file-word-2',
		color: '#2196F3',
	},
};
